import React from 'react';
import { CheckIcon, LineNoHasFeatureIcon } from '@icons';

const planFeatureContent = [
  {
    titleText: 'Usage',
    tableContent: [
      {
        features: 'Number of users',
        free: 'Includes 2 users',
        starter: 'Includes 15 users',
        team: 'Includes 20 users',
        enterprise: 'Includes 25 users'
      },
      {
        features: 'Unlimited proof links',
        free: 'Unlimited',
        starter: 'Unlimited',
        team: 'Unlimited',
        enterprise: 'Unlimited'
      },
      {
        features: 'Unlimited free reviewers',
        free: 'Unlimited',
        starter: 'Unlimited',
        team: 'Unlimited',
        enterprise: 'Unlimited'
      },
      {
        features: 'Secure storage',
        free: '2GB free storage',
        starter: '500GB free storage',
        team: '1TB free storage',
        enterprise: 'Custom storage packages'
      },
      {
        features: 'Storage add-ons',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: '250GB increments',
        team: '250GB increments',
        enterprise: 'Custom'
      }
    ]
  },
  {
    titleText: 'Workspaces & Projects',
    tableContent: [
      {
        features: 'Number of workspaces',
        free: '1 workspace',
        starter: '5 workspaces',
        team: '10 workspaces',
        enterprise: 'Unlimited'
      },
      {
        features: 'Number of projects',
        free: '1 project',
        starter: '5 projects',
        team: '15 projects',
        enterprise: 'Unlimited projects'
      },
      {
        features: 'Searchable Media Library',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Creative brief per project',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Personalized activity dashboard',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Organize media in private projects',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Organize media in private folders',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      }
    ]
  },
  {
    titleText: 'Supported Media',
    tableContent: [
      {
        features: 'Review video and audio (MP4, MOV, WAV, etc)',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Review images (PNG, JPEG, TIFF, etc)',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Review Adobe Creative Suite (PSD, AI, etc)',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features:
          'Review documents, excel and presentations (DOC, PDF, XLS, PPT)',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Review animated GIFs',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Review CAD files (2D)',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Review static website screenshots',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      }
    ]
  },
  {
    titleText: 'Creative Feedback & Collaboration',
    tableContent: [
      {
        features:
          'Real-time commenting on imagery, photography, presentations, PDFs and more',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Text highlighting on documents, PDFs and more',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Time-stamped comments on videos',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Range-based comments on videos',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Markup an asset (arrows, shapes, freeform, text, pins)',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Drop pins on images, PDFs, presentations',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Filter and sort comments',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Unlimited versions',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Layered version management',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Version stack different file formats',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Download original file',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Download video proxies',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Thumbnail page viewer for PDFs and presentations',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Copy comments',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Download comments (CSV, XML, plain text)',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: '@mentions to send notification to another team member',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Priority stakeholder comments',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        team: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      }
    ]
  },
  {
    titleText: 'Share for Review',
    tableContent: [
      {
        features: 'External share link for single file',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'External share link for multiple files',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Disable comments on share links',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Disable downloads on share links',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Share one or multiple versions on share link',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'View, manage and delete active share links',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Mobile optimized share links',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Add custom message to share links',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Password-protected external share links',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      }
    ]
  },
  {
    titleText: 'Multi-Stage Approval Workflows',
    tableContent: [
      {
        features: 'Approval routing builder',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Approval stages',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: '1 stage per approval routing',
        team: '3 stages per approval routing',
        enterprise: 'Custom'
      },
      {
        features: 'Approval Routing Reviewers',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: 'Up to 5 reviewers per stage',
        team: 'Up to 10 reviewers per stage',
        enterprise: 'Unlimited'
      },
      {
        features: 'Approval status dashboard per project',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Specify when stage is completed',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Set primary decision maker',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Option to skip reviewer decisions',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Set upload permissions',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Automatic approval deadline reminders',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Set approval routing due dates',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Upload new version while workflow in progress',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Customize approval notifications',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Pause approval workflow',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Edit in-progress approval workflow',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Restart approval workflow',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Add password to approval routing invites',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Add same reviewer to multiple stages',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Send approval links with due dates and media library',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Add custom message to approval invites',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Approval workflow templates',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        team: '2 workflow templates',
        enterprise: 'Unlimited workflow templates'
      },
      {
        features: 'Lock decisions once comments submitted',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Restrict downloads until media is approved',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Batch approval routing',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        team: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      }
    ]
  },

  {
    titleText: 'Task Management',
    tableContent: [
      {
        features: 'Turn creative feedback into tasks',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Create custom groupings for tasks',
        free: '1 custom task group per project',
        starter: '5 custom task groups per project',
        team: '10 custom task groups per project',
        enterprise: 'Unlimited'
      },
      {
        features: 'Assign project or media to task',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Assign tasks',
        free: '1 assignee per task',
        starter: '1 assignee per task',
        team: 'Multiple assignees per task',
        enterprise: 'Multiple assignees per task'
      },
      {
        features: 'Set task status',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Set task due date',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Set task priority',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Real-time commenting in tasks',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Task activity log',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'View tasks per project',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Filter & sort tasks',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Customize task notifications',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Universal task view',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Asana, monday.com and more integrations',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      }
    ]
  },
  {
    titleText: 'Integrations',
    tableContent: [
      {
        features: 'Slack Integration',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Asana Integration',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'monday.com Integration',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'DAM / Cloud Storage Integrations',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        team: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'API integrations (Webhooks)',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        team: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Education Gradebook',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        team: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      }
    ]
  },

  {
    titleText: 'Organization Management',
    tableContent: [
      {
        features: 'Custom organization domain',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Monitor storage usage',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Workspace invite links',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Project invite links',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Manage contacts',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Group management',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Project timeline log',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'White-label organization domain',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        team: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Multiple admins',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        team: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Enterprise access management',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        team: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      }
    ]
  },
  {
    titleText: 'Security & Privacy',
    tableContent: [
      {
        features: 'SOC 2 Type II ',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'AES-256 bit encryption',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Google Single Sign-On',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Set user roles',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Set user permissions',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Set group access',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Two-factor authentication',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Single Sign-On',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        team: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      }
    ]
  },
  {
    titleText: 'Customer Success',
    tableContent: [
      {
        features: 'Knowledge Base',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'In-product onboarding',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Live chat support',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Email support',
        free: <CheckIcon className="plan-features-list_icon-active" />,
        starter: <CheckIcon className="plan-features-list_icon-active" />,
        team: <CheckIcon className="plan-features-list_icon-active" />,
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Onboarding',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        team: '1 hour onboarding',
        enterprise: 'Custom'
      },
      {
        features: 'Custom implementation',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        team: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      },
      {
        features: 'Priority support',
        free: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        starter: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        team: (
          <LineNoHasFeatureIcon className="plan-features-list_icon-disabled" />
        ),
        enterprise: <CheckIcon className="plan-features-list_icon-active" />
      }
    ]
  }
];

export default planFeatureContent;
